import { Button } from "@mui/material";
import React from "react";
import { DayliPlanContext } from "../context/dayliPlanContext";

const SearchButton = (): React.JSX.Element => {
  const {
    isLoading,
    fetchAppointments,
  }: {
    isLoading: boolean;
    fetchAppointments: () => Promise<void>;
  } = React.useContext(DayliPlanContext);

  return (
    <Button
      disabled={isLoading}
      onClick={fetchAppointments}
      sx={{
        height: "100%",
      }}
      fullWidth
      variant="contained"
      color="primary"
    >
      {isLoading ? "Lädt..." : "Suchen"}
    </Button>
  );
};

export default SearchButton;
